import { HMO_ROLE, isHmoAuthorityRole } from "./hmoRoles";

const resolveRoleCode = (
  auth: { role?: { role?: string | null } | null } | null,
): string => {
  const fromAuth = String(auth?.role?.role || "").trim().toUpperCase();
  if (fromAuth) return fromAuth;

  const storedRole = localStorage.getItem("role");
  if (!storedRole) return "";
  try {
    const parsed = JSON.parse(storedRole);
    if (typeof parsed === "string") return parsed.trim().toUpperCase();
    if (parsed?.role) return String(parsed.role).trim().toUpperCase();
  } catch {
    return storedRole.replace(/^"|"$/g, "").trim().toUpperCase();
  }
  return "";
};

/**
 * Hospital portal vs internal (G7) patient list UI.
 * HMO authority roles (CPD, Finance, Admin, etc.) always use authority UI —
 * even if localStorage still has stale hospital flags from a prior session.
 */
export const isHospitalPatientListUser = (
  auth: { role?: { role?: string | null } | null; isHospital?: boolean } | null,
): boolean => {
  const role = resolveRoleCode(auth);
  if (isHmoAuthorityRole(role)) return false;
  if (role === HMO_ROLE.HSP_USER) return true;
  if (auth?.isHospital === true) return true;

  const userStr = localStorage.getItem("user");
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      const userRole = String(user?.role?.role || user?.role || "")
        .trim()
        .toUpperCase();
      if (isHmoAuthorityRole(userRole)) return false;
      if (userRole === HMO_ROLE.HSP_USER) return true;

      if (user?.isHospital === true || user?.hospitalUser === true) {
        return true;
      }
      if (user?.portalContext?.portalUserType === "HSP") {
        return true;
      }
      if (user?.portalContext?.portalUserType === "HMO") {
        return false;
      }
    } catch {
      /* ignore */
    }
  }

  return false;
};
